const questions = [
    {
        questionText: 'What is your name?',
        answerOptions: [
        ],
    },
    {
        questionText: 'What is your email?',
        answerOptions: [
        ],
    },
    {
        questionText: 'Select your gender',
        answerOptions: [
            'Male',
            'Female'
        ],
    },
    {
        questionText: 'Do you have your raw DNA data? (if you have been tested by other genetic testing providers)',
        answerOptions: [
            'Yes',
            'No'
        ],
    },
    {
        questionText: 'Date of Birth',
        answerOptions: [
        ],
    },
    {
        questionText: "What's your Weight?",
        answerOptions: [
        ],
    },
    {
        questionText: "What's your Height?",
        answerOptions: [
        ],
    },
    {
        questionText: 'What are your Dietary Restrictions',
        answerOptions: [
            'Vegetarian',
            'Vegan',
            'Gluten Free',
            'Not Applicable'
        ],
    },
    {
        questionText: 'How would you describe your Activity Level',
        answerOptions: [
            'Little to no exercise',
            'Light Exercise(1-3 days per week)',
            'Moderate exercise (3-5 days per week)',
            'Heavy exercise (6-7 days per week)',
            'Very heavy exercise (twice per day)',
        ],
    },
    {
        questionText: "What's your Ethnicity",
        answerOptions: [
            { value: 'Chinese', label: 'Chinese' },
            { value: 'Malay', label: 'Malay' },
            { value: 'Japanese', label: 'Japanese' },
            { value: 'Korean', label: 'Korean' },
            { value: 'Vietnamese', label: 'Vietnamese' },
            { value: 'Thai', label: 'Thai' },
            { value: 'Indonesian', label: 'Indonesian' },
            { value: 'Filipino', label: 'Filipino' },
            { value: 'Caucasian', label: 'Caucasian' },
            { value: 'African / Afro-Caribbean', label: 'African / Afro-Caribbean' },
            { value: 'American Indian / Alaska Native (includes people of Central and South American origin with tribal affiliation)', label: 'American Indian / Alaska Native (includes people of Central and South American origin with tribal affiliation)' },
            { value: 'Hispanic / Latino', label: 'Hispanic / Latino' },
            { value: 'Pacific Islander (includes Hawaii, Guam, Samoa, etc.)', label: 'Pacific Islander (includes Hawaii, Guam, Samoa, etc.)' },
            { value: 'South Asian (includes people from Afghanistan, India, Pakistan, Bangladesh, Sri Lanka and Nepal)', label: 'South Asian (includes people from Afghanistan, India, Pakistan, Bangladesh, Sri Lanka and Nepal)' },
            { value: 'Indigenous Australian (Aboriginal, Torres Strait Islander)', label: 'Indigenous Australian (Aboriginal, Torres Strait Islander)' },
            { value: 'Others', label: 'Others' },
        ]
    },
    {
        questionText: "Country of Birth",
        answerOptions: [
        ],
    },
    {
        questionText: "For an accurate assessment of health & wellness risk predispositions, it is important to know your ancestry. To the best of your ability, please provide us with the ancestry (origins) of your grandparents (e.g. 50% Asian & 50% European or 100% West Asian etc.) Please indiciate NA if you are unsure.",
        answerOptions: [
        ],
    },
    {
        questionText: "Genetic Report Language if applicable",
        answerOptions: [
            { value: 'english', label: 'English' },
            { value: 'traditional chinese', label: 'Traditional Chinese' },
            { value: 'simplified chinese', label: 'Simplified Chinese' },
            { value: 'japanese', label: 'Japanese' },
            { value: 'bahasa indonesia', label: 'Bahasa Indonesia' },
            { value: 'vietnamese', label: 'Vietnamese' },
            { value: 'Na', label: 'NA' }
        ],
    },
    {
        questionText: "Please indicate your choice of Boost flavour if applicable",
        answerOptions: [
            'Mixed Berry',
            'Orange',
            'Pineapple',
            'NA'
        ],
    },
    {
        questionText: "I am generally better at exercises/sports such as lengthy hiking, marathon, race walking, triathlon and other sports that require stamina.",
        answerOptions: [
            'Strongly Disagree',
            'Disagree',
            'Not Sure',
            'Agree',
            'Strongly Agree',
        ],
    },
    {
        questionText: "I am generally better at exercises/sports such as weight lifting, tennis, martial arts and kickboxing, sprinting and fast running that require substantial strength and power over short periods of time. ",
        answerOptions: [
            'Strongly Disagree',
            'Disagree',
            'Not Sure',
            'Agree',
            'Strongly Agree',
        ],
    },
    {
        questionText: "I have frequently experienced prolonged soreness in my muscles after workout that has taken a long time to heal.",
        answerOptions: [
            'Strongly Disagree',
            'Disagree',
            'Not Sure',
            'Agree',
            'Strongly Agree',
        ],
    },
    {
        questionText: "I have frequently experienced sports related injuries in my joints and muscles.",
        answerOptions: [
            'Strongly Disagree',
            'Disagree',
            'Not Sure',
            'Agree',
            'Strongly Agree',
        ],
    },
    {
        questionText: "I often feel out of breath very soon when I am exercising.",
        answerOptions: [
            'Strongly Disagree',
            'Disagree',
            'Not Sure',
            'Agree',
            'Strongly Agree',
        ],
    },
    {
        questionText: "I do not feel motivated to do sports or exercises at all and have a hard time creating a fitness routine for myself, although I know it is good for me.",
        answerOptions: [
            'Strongly Disagree',
            'Disagree',
            'Not Sure',
            'Agree',
            'Strongly Agree',
        ],
    },
    {
        questionText: "I have a very hard time losing weight, even if I control my diet and do exercises.",
        answerOptions: [
            'Strongly Disagree',
            'Disagree',
            'Not Sure',
            'Agree',
            'Strongly Agree',
        ],
    },
    {
        questionText: "When I exercise for some time, my muscles develop and shape very quickly.",
        answerOptions: [
            'Strongly Disagree',
            'Disagree',
            'Not Sure',
            'Agree',
            'Strongly Agree',
        ],
    },
    {
        questionText: "I have had frequent muscle cramps during swimming, walking or other exercise activity. ",
        answerOptions: [
            'Strongly Disagree',
            'Disagree',
            'Not Sure',
            'Agree',
            'Strongly Agree',
        ],
    },
    {
        questionText: "There is obesity or overweightness running in my family (including or excluding myself).",
        answerOptions: [
            'Strongly Disagree',
            'Disagree',
            'Not Sure',
            'Agree',
            'Strongly Agree',
        ],
    },
    {
        questionText: "My skin sometimes feels tight and when it is stretched, it takes a bit of time for it to smoothen out again. ",
        answerOptions: [
            'Strongly Disagree',
            'Disagree',
            'Not Sure',
            'Agree',
            'Strongly Agree',
        ],
    },
    {
        questionText: "My skin often feels dry and I have to use moisturizers quite often.",
        answerOptions: [
            'Strongly Disagree',
            'Disagree',
            'Not Sure',
            'Agree',
            'Strongly Agree',
        ],
    },
    {
        questionText: "My skin gets easily irritated ",
        answerOptions: [
            'Strongly Disagree',
            'Disagree',
            'Not Sure',
            'Agree',
            'Strongly Agree',
        ],
    },
    {
        questionText: "When outside or on the beach during a sunny day, my skin turns red fast and I get sunburns if I don’t use sunscreen.",
        answerOptions: [
            'Strongly Disagree',
            'Disagree',
            'Not Sure',
            'Agree',
            'Strongly Agree',
        ],
    },
    {
        questionText: "I am often told that I look much younger than my age.",
        answerOptions: [
            'Strongly Disagree',
            'Disagree',
            'Not Sure',
            'Agree',
            'Strongly Agree',
        ],
    },
    {
        questionText: "What are your main skin concerns? Please select all that apply.",
        answerOptions: [
            { value: 'Winkles/Sagging', label: 'Winkles/SaggingAcne' },
            { value: 'Pigmentation / Uneven skin tone', label: 'Pigmentation / Uneven skin tone' },
            { value: 'Dryness', label: 'Dryness' },
            { value: 'Redness and Sensitivity', label: 'Redness and Sensitivity' },
            { value: 'None of the above', label: 'None of the above' },
            { value: 'Others', label: 'Others' },
        ],
    },
    {
        questionText: "Please check which of the following symptoms have you felt or exhibited frequently (tangible enough for you to have noticed it several times over this period)",
        answerOptions: [
            { value: 'Abdominal pain after intake of dairy product', label: 'Abdominal pain after intake of dairy product' },
            { value: 'Abdominal pain/cramp after meal', label: 'Abdominal pain/cramp after meal' },
            { value: 'Abnormal Heart Rhythm', label: 'Abnormal Heart Rhythm' },
            { value: 'Acne', label: 'Acne' },
            { value: 'Bad Breath', label: 'Bad Breath' },
            { value: 'Blurred Vision', label: 'Blurred Vision' },
            { value: 'Brittle Nails', label: 'Brittle Nails' },
            { value: 'Constipation', label: 'Constipation' },
            { value: 'Depression', label: 'Depression' },
            { value: 'Diarrhea', label: 'Diarrhea' },
            { value: 'Dizziness', label: 'Dizziness' },
            { value: 'Dry Eyes, Hair or Skin', label: 'Dry Eyes, Hair or Skin' },
            { value: 'Easy bruising and slow wound healing', label: 'Easy bruising and slow wound healing' },
            { value: 'Eczema', label: 'Eczema' },
            { value: 'Frequent Colds', label: 'Frequent Colds' },
            { value: 'Frequent Fatigue', label: 'Frequent Fatigue' },
            { value: 'Frequent Headaches', label: 'Frequent Headaches' },
            { value: 'Frequent Nose Bleeds', label: 'Frequent Nose Bleeds' },
            { value: 'Frequent Thirst', label: 'Frequent Thirst' },
            { value: 'Hair Loss (Non-baldness related)', label: 'Hair Loss (Non-baldness related)' },
            { value: 'Insomnia', label: 'Insomnia' },
            { value: 'Irritability', label: 'Irritability' },
            { value: 'Joint pain', label: 'Joint pain' },
            { value: 'Loss of Appetite', label: 'Loss of Appetite' },
            { value: 'Moodiness', label: 'Moodiness' },
            { value: 'Mouth Lesions', label: 'Mouth Lesions' },
            { value: 'Muscle Cramps', label: 'Muscle Cramps' },
            { value: 'Muscle Weakness', label: 'Muscle Weakness' },
            { value: 'Nervousness', label: 'Nervousness' },
            { value: 'Reduced Night Vision', label: 'Reduced Night Vision' },
            { value: 'Restlessness', label: 'Restlessness' },
            { value: 'Sensitivity to Light', label: 'Sensitivity to Light' },
            { value: 'Shortness of breath', label: 'Shortness of breath' },
            { value: 'Temporary Confusion / Absent mindedness', label: 'Temporary Confusion / Absent mindedness' },
            { value: 'Very Pale Skin', label: 'Very Pale Skin' },
            { value: 'Lactose Intolerant', label: 'Lactose Intolerant' },
            { value: 'None of the above', label: 'None of the above' }
        ],
    },
    {
        questionText: "Do you smoke?",
        answerOptions: [
            'No',
            '1 - 5 Cigarettes/day',
            '6 - 10 Cigarettes/day',
            'More than 10 Cigarettes/day'
        ],
    },
    {
        questionText: "How often do you exercise per week: Endurance Workout (Eg. cardio exercises at the gym, aerobics, running, cycling)",
        answerOptions: [
            'Not at all',
            '30 mins',
            '60 mins',
            'More than 60 mins'
        ],
    },
    {
        questionText: "How often do you exercise per week: Muscle Sport (Eg. racket games, swimming, yoga, pilates, muscle toning)",
        answerOptions: [
            'Not at all',
            '30 mins',
            '60 mins',
            'More than 60 mins',
        ],
    },
    {
        questionText: "How many glasses of alcoholic drink do you drink per week? (E.g beer, wine, sake, cocktails, whiskey,brandy etc)",
        answerOptions: [
            'None',
            '1 - 2 glasses',
            '3 - 4 glasses',
            'More than 4 glasses',
        ],
    },
    {
        questionText: "How long do you usually spend in the sun daily? (without sunscreen)",
        answerOptions: [
            'Not at all',
            '10 mins',
            '20 mins',
            '30 mins',
            'More than 30 mins'
        ],
    },
    {
        questionText: "Do you feel sufficiently rested?",
        answerOptions: [
            'Yes',
            'No',
            'Sometimes',
        ],
    },
    {
        questionText: "Do you suffer from stress?",
        answerOptions: [
            'Never',
            'Sometimes',
            'Often',
        ],
    },
    {
        questionText: "Do you have a physically-demanding job?",
        answerOptions: [
            'Yes',
            'No',
        ],
    },
    {
        questionText: "How many servings of fruit do you eat daily? (1 serving is roughly a apple/pear/orange/banana, a slice of papaya/melon or a small bunch of grapes)",
        answerOptions: [
            'None',
            '1-2',
            '3-4',
            'More'
        ],
    },
    {
        questionText: "How many servings of vegetables do you eat daily? (1 serving is 1 cup of cooked vegetables or a side plate of salad)",
        answerOptions: [
            'None',
            '1-2',
            '3-4',
            'More'
        ],
    },
    {
        questionText: "Are you a vegetarian?",
        answerOptions: [
            'Yes',
            'No'
        ],
    },
    {
        questionText: "How many times do you eat fish per week?",
        answerOptions: [
            'None',
            '1-2',
            '3-4',
            'More'
        ],
    },
    {
        questionText: "How many times do you eat meat per week?",
        answerOptions: [
            'None',
            '1-2',
            '3-4',
            'More'
        ],
    },
    {
        questionText: "Do you eat on a regular basis “junk food”? (Eg. potato chips, candy bars, processed snacks, etc)",
        answerOptions: [
            'Yes',
            'No'
        ],
    },
    {
        questionText: "Do you drink regularly sweetened beverages? (with sugar or artificial sweetener such as Equal)",
        answerOptions: [
            'Yes',
            'No'
        ],
    },
    {
        questionText: "Do you drink regularly carbonated soft drinks?",
        answerOptions: [
            'Yes',
            'No'
        ],
    },
    {
        questionText: "Please select any of the conditions below if applicable. (You can select more than one)",
        answerOptions: [
            { value: 'Suffer from diarrhoea', label: 'Suffer from diarrhoea' },
            { value: 'Feel constipated', label: 'Feel constipated' },
            { value: 'Feel bloated', label: 'Feel bloated' },
            { value: 'Feel tired/exhausted', label: 'Feel tired/exhausted' },
            { value: 'Suffer memory loss', label: 'Suffer memory loss' },
            { value: 'Suffer hair loss', label: 'Suffer hair loss' },
            { value: 'Brittle nails', label: 'Brittle nails' },
            { value: 'Dry/scaly skin', label: 'Dry/scaly skin' },
            { value: 'Poor eye-sight (Eg. short-sightedness, far-sightedness, astigmatism, etc)', label: 'Poor eye-sight (Eg. short-sightedness, far-sightedness, astigmatism, etc)' },
            { value: 'Suffer from joint pain', label: 'Suffer from joint pain' },
            { value: 'Weak joints', label: 'Weak joints' },
            { value: 'No, I do not have any of the above conditions.', label: 'No, I do not have any of the above conditions.' },
            { value: 'Others', label: 'Others' },
        ],
    },
    {
        questionText: "Select what your are allergic/have an allergic reaction to (You can select more than one)",
        answerOptions: [
            { value: 'Shell fish', label: 'Shell fish' },
            { value: 'Other seafood', label: 'Other seafood' },
            { value: 'Nuts', label: 'Nuts' },
            { value: 'Raw vegetables', label: 'Raw vegetables' },
            { value: 'Raw fruits (especially apples or citruses)', label: 'Raw fruits (especially apples or citruses)' },
            { value: 'Pollen', label: 'Pollen' },
            { value: 'UV-Light or Sunlight', label: 'UV-Light or Sunlight' },
            { value: 'Gluten', label: 'Gluten' },
            { value: 'No, I do not have any of the above conditions.', label: 'No, I do not have any of the above conditions.' },
            { value: 'Others', label: 'Others' },
        ],
    },
    {
        questionText: "Select if you’ve suffered from any of the following diseases (You can select more than one)",
        answerOptions: [
            { value: 'Cardiovascular (Heart) Disease', label: 'Cardiovascular (Heart) Disease' },
            { value: 'Stroke', label: 'Stroke' },
            { value: 'Rheumatism', label: 'Rheumatism' },
            { value: 'Cancer', label: 'Cancer' },
            { value: 'Diabetes', label: 'Diabetes' },
            { value: 'No, I do not have any of the above conditions.', label: 'No, I do not have any of the above conditions.' },
            { value: 'Others', label: 'Others' },
        ],
    },
    {
        questionText: "Many drugs are depleting the body of vital nutrients. Please mark those drugs you are currently taking (You can select more than one)",
        answerOptions: [
            { value: 'Not on any medication', label: 'Not on any medication' },
            { value: 'Antibiotics (E.g Amoxicillin)', label: 'Antibiotics (E.g Amoxicillin)' },
            { value: 'Anti depressants (E.g Escitalopram)', label: 'Anti depressants (E.g Escitalopram)' },
            { value: 'Blood_Pressure Medication (E.g Perindopril)', label: 'Blood Pressure Medication (E.g Perindopril)' },
            { value: 'Cholesterol Lowering Medication (E.g Atorvastatin)', label: 'Cholesterol Lowering Medication (E.g Atorvastatin)' },
            { value: 'Diabetes Medication (E.g Metformin)', label: 'Diabetes Medication (E.g Metformin)' },
            { value: 'Diuretics (E.g Furosemide)', label: 'Diuretics (E.g Furosemide)' },
            { value: 'Hormone Medication (E.g Estradiol)', label: 'Hormone Medication (E.g Estradiol)' },
            { value: 'Facilitate Breathing (E.g Salbutamol)', label: 'Facilitate Breathing (E.g Salbutamol)' },
            { value: 'Gout (E.g Allopurinol)', label: 'Gout (E.g Allopurinol)' },
            { value: 'Salicylate (Eg. Aspirin)', label: 'Salicylate (Eg. Aspirin)' },
            { value: 'Thyroid Medication (E.g L-Thyroxine)', label: 'Thyroid Medication (E.g L-Thyroxine)' },
            { value: 'Blood_thinning medication (E.g Warfarin)', label: 'Blood thinning medication (E.g Warfarin)' },
            { value: 'Painkillers / Non-steroidal anti-inflammatories (E.g Ibuprofen and Panadol)', label: 'Painkillers / Non-steroidal anti-inflammatories (E.g Ibuprofen and Panadol)' },
            { value: 'Other Drugs Not Listed', label: 'Other Drugs Not Listed' }
        ],
    },
    {
        questionText: "Other medications: e.g. Warfarin, Amoxil, etc.",
        answerOptions: [
            'Yes',
            'No'
        ],
    },
    {
        questionText: "Other health conditions/concerns: e.g. fall sick easily, migraine, etc.",
        answerOptions: [
            'Yes',
            'No'
        ],
    },
    {
        questionText: "Are you pregnant or planning to become pregnant?",
        answerOptions: [
            'Yes',
            'No'
        ],
    },
    {
        questionText: "Are you breastfeeding?",
        answerOptions: [
            'Yes',
            'No'
        ],
    },
    {
        questionText: "Are you taking any hormonal contraceptions?",
        answerOptions: [
            'Yes',
            'No'
        ],
    },
    {
        questionText: "Please choose 3 of your most important health goals.",
        answerOptions: [
            { value: 'Lose weight', label: 'Lose weight' },
            { value: 'Improved energy', label: 'Improved energy' },
            { value: 'Improved memory/ cognitive function', label: 'Improved memory/ cognitive function' },
            { value: 'Improved mood', label: 'Improved mood' },
            { value: 'Improved fitness', label: 'Improved fitness' },
            { value: 'Improved immune health', label: 'Improved immune health' },
            { value: 'Decreased pain', label: 'Decreased pain' },
            { value: 'Improved skin health', label: 'Improved skin health' },
            { value: 'Others', label: 'Others' }
        ],
    },
    {
        questionText: "Please read our Terms of Use:",
        answerOptions: [
            { terms: "Please find our Research Consent document here (https://eterna-life.com/pages/research-consent). The purpose of Genebank Research is to make new discoveries about genetics, treatment and other factors behind diseases and traits. If you agree to this consent, you allow Genebank researchers to use your information (including your Genetic Information and your responses to research surveys) for research activities.",
            agree: "I understand and agree to be a research subject."},
            { terms: "You agree that EternaDNA may collect, use and disclose your personal data, which you have provided in this form, for providing marketing material that you have agreed to receive, in accordance with the Personal Data Protection Act and our privacy policy.",
            agree:"I agree to receive marketing material that includes information on new products and services and updates on latest promotions"},
            { terms: "Please find our Terms of Service (TOS) here (https://eterna-life.com/pages/terms-of-service). Your use of EternaDNA's services is subject to the terms of the legal agreement between you and EternaDNA set forth in these TOS. In order to use the services, you must first agree to the TOS. In this case, by acknowledging and agreeing to the TOS, EternaDNA will treat your use of the services as acceptance from this point onwards.", 
            agree: "I understand and accept the Terms of Service*"},
        ],
    },
]

export default questions